export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-300">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-flashlight-fill text-sm text-background-50"></i>
              </div>
              <span className="font-heading font-bold text-base text-background-50">每日爆料</span>
            </div>
            <p className="text-xs text-foreground-400 leading-relaxed">
              51每日爆料官网入口，提供最新最全的吃瓜爆料一手资讯。娱乐圈八卦、网红动态、社会热点，尽在每日爆料网。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <div className="space-y-2">
              <a href="#hero" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#ranking" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">吃瓜热度榜</a>
              <a href="#app" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">APP下载</a>
              <a href="#index" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">专题合集</a>
              <a href="#faq" className="block text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">联系我们</h4>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-mail-line"></i>
                <span>tougao@meiribaoliao.com</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-wechat-line"></i>
                <span>微信：mrbl_tougao</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-smartphone-line"></i>
                <span>APP：搜索"51每日爆料"</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <div className="space-y-2">
              <p className="text-xs text-foreground-500">更多合作伙伴即将上线，敬请期待。</p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2023-2026 每日爆料 meiribaoliao.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">用户协议</a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}